import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  propsQuotesState,
  QuoteCoords,
  QuoteDetail,
  QuoteItem,
  QuoteProduct,
  Weather,
} from './interfaces';

export const ALL_PRODUCTS: QuoteProduct[] = ['soja', 'milho', 'boi_gordo', 'dolar'];

const initialState: propsQuotesState = {
  uf: null,
  useCurrentLocation: true,
  coords: null,
  weatherCity: null,
  enabledProducts: ALL_PRODUCTS,
  items: [],
  weather: null,
  detailByProduct: {},
  loading: false,
  weatherLoading: false,
  detailLoading: false,
  error: false,
  lastFetchedAt: undefined,
};

const quotesSlice = createSlice({
  name: 'quotes',
  initialState,
  reducers: {
    quotesRequest: (state) => {
      state.loading = true;
      state.error = false;
    },
    quotesSuccess: (state, action: PayloadAction<{ items: QuoteItem[]; fetchedAt: string }>) => {
      state.items = action.payload.items;
      state.lastFetchedAt = action.payload.fetchedAt;
      state.loading = false;
      state.error = false;
    },
    quotesFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    weatherRequest: (state) => {
      state.weatherLoading = true;
    },
    weatherSuccess: (state, action: PayloadAction<Weather | null>) => {
      state.weather = action.payload;
      state.weatherLoading = false;
    },
    weatherFailure: (state) => {
      state.weatherLoading = false;
    },
    detailRequest: (state) => {
      state.detailLoading = true;
    },
    detailSuccess: (state, action: PayloadAction<QuoteDetail>) => {
      state.detailByProduct[action.payload.product] = action.payload;
      state.detailLoading = false;
    },
    detailFailure: (state) => {
      state.detailLoading = false;
    },
    setManualUf: (state, action: PayloadAction<string>) => {
      state.uf = action.payload;
      state.useCurrentLocation = false;
      state.coords = null;
    },
    setLocation: (
      state,
      action: PayloadAction<{ uf: string | null; coords: QuoteCoords }>,
    ) => {
      state.uf = action.payload.uf;
      state.coords = action.payload.coords;
      state.useCurrentLocation = true;
      state.weatherCity = null;
    },
    setWeatherCity: (state, action: PayloadAction<string | null>) => {
      state.weatherCity = action.payload?.trim() ? action.payload.trim() : null;
    },
    setEnabledProducts: (state, action: PayloadAction<QuoteProduct[]>) => {
      state.enabledProducts = action.payload;
    },
  },
});

export const {
  quotesRequest, quotesSuccess, quotesFailure,
  weatherRequest, weatherSuccess, weatherFailure,
  detailRequest, detailSuccess, detailFailure,
  setManualUf, setLocation, setWeatherCity, setEnabledProducts,
} = quotesSlice.actions;
export default quotesSlice.reducer;
